import { errorInit } from 'redux/reducers/init';
import { clearError, throwError } from 'redux/actions/actions';

import { createReducer } from '@reduxjs/toolkit';

const error = createReducer(errorInit, {
  [throwError.type]: (state, action) => {
    const { error } = action.payload;
    state.error = error;
  },
  [clearError.type]: (state, action) => {
    state.error = null;
  },
});

export default error;
